// extracted by mini-css-extract-plugin
export var quantityInput = "_p9-0";